import Optimizely from '@talpanetwork/optimizely-client';
import WebStorage from '@talpanetwork/optimizely-client/Storage/Storage.web';
import vendorAllowed from 'util/consent';
import { firstVisitData } from 'analytics';
import { parse as parseQuerystring } from 'querystringify';

const optimizely = (() => {
  let instance;
  let featuresCache = {};

  function createInstance() {
    const object = new Optimizely({
      // Required, URL to the datafile
      datafileUrl: process.env.REACT_APP_OPTIMIZELY_DATEFILE,

      // Optional, enable debug mode, this adds logs to the console
      // debug: true,

      storageClass: WebStorage,
      // Add instance to window ( window.__optimizelyInstance ) required by TAQ

      addToWindow: true,

      // has optimizely consent
      hasConsent: vendorAllowed(VENDORS.OPTIMIZELY),
    });
    window.optimizelyReady = true;
    return object;
  }

  function getInstance() {
    if (!instance) {
      instance = createInstance();
    }
    return instance;
  }

  function isFeatureEnabled(featureKey) {
    if (!featuresCache[featureKey]) {
      featuresCache[featureKey] = getInstance().isFeatureEnabled(featureKey);
    }
    return featuresCache[featureKey];
  }

  function activate(experimentKey) {
    return getInstance().activate(experimentKey);
  }

  function getFeatureVariable(featureKey, variableKey, defaultValue = null) {
    if (!isFeatureEnabled(featureKey)) {
      return defaultValue;
    }
    return getInstance().getFeatureVariable(featureKey, variableKey) || defaultValue;
  }

  function reset() {
    featuresCache = {};
  }

  function track(eventkey, eventData = {}) {
    return getInstance().track(eventkey, eventData);
  }

  // Taq will set the attributes with the persistent on false. We can overwrite it if we set persistent on true
  // To clear the perstistent attribute for the user, set the value of the attribute to null.
  // When the value of the attribute is null, taq will overwite the attribute again
  function overwriteTaqAttributes() {
    // If consent for optimizely is not given or tracking protection is enabled in private mode in firefox the datatfile is not available
    const optimizelyInstance = getInstance();
    if (optimizelyInstance.datafile && optimizelyInstance.datafile.datafile) {
      optimizelyInstance.updateUsersAttributes(
        {
          page_url: window.location.pathname,
        },
        true // persistent
      );
    }
  }

  function setAttributes() {
    const queryString = parseQuerystring(window.location.search);
    const fistVisit = firstVisitData();
    return {
      first_visit: parseInt(fistVisit.date, 10),
      first_visit_url: fistVisit.url,
      referrer_url: (queryString && queryString.utm_source) || null,
    };
  }

  return {
    getInstance,
    isFeatureEnabled,
    getFeatureVariable,
    reset,
    track,
    overwriteTaqAttributes,
    setAttributes,
    activate,
  };
})();

export default optimizely;
